/* eslint-disable @typescript-eslint/no-explicit-any */
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { IGeoJSONFeatureCollection } from '../interfaces/geo';
import { Store } from '@ngxs/store';
import { PredictorModelActions } from 'src/app/state/predictor-model/predictor-model.actions';
import { TerrainLoadingStatus } from '../enums/terrain-loading-status';

@Injectable({
  providedIn: 'root',
})
export class FileUploadService {
  private http: HttpClient;

  constructor(private httpClient: HttpClient,
    private store: Store) {
    this.http = this.httpClient;
  }

  public uploadDem(file: File, studyArea: string,licenseNumber:string|null): Observable<any> {
    this.store.dispatch(new PredictorModelActions.SetTerrainLoadingStatus(TerrainLoadingStatus.Uploading));
    return this.upload(file, studyArea, 'api/terrain/UploadDem', licenseNumber??'');
  }

  public uploadShapefile(
    file: File,
    simulationId: string
  ): Observable<IGeoJSONFeatureCollection> {
    const formData: FormData = new FormData();
    formData.append('file', file);
    formData.append('requestId', simulationId);
    return this.http.post<IGeoJSONFeatureCollection>(
      '/api/Import/Shapefile',
      formData
    );
  }

  private upload(
    file: File,
    studyArea: string,
    endpoint: string,
    licenseNumber: string
  ): Observable<any> {
    const formData: FormData = new FormData();
    formData.append('file', file);
    formData.append('studyAreaName', studyArea);
    formData.append('licenseNumber', licenseNumber);
    return this.http.post(endpoint, formData, {
      reportProgress: true,
      observe: 'events',
    });
  }
}
